import {Outlet, useLocation} from '@remix-run/react';
import {Col, Container, Nav, Row} from 'react-bootstrap';

import {NavLink} from '../components/atoms/nav-link';

export default function DocsLayout() {
  const location = useLocation();
  return (
    <Container>
      <Row>
        <Col xs={3}>
          <Nav
            activeKey={location.pathname}
            variant="pills"
            className="flex-column"
          >
            <NavLink href="/docs">Documentation</NavLink>
            <NavLink href="/docs/service-integrations">CI Integrations</NavLink>
            <NavLink href="/docs/manual-setup">Manual Setup</NavLink>
            <NavLink href="/docs/report-formats">General Formats</NavLink>
            <NavLink href="/docs/test-splitting">Test Splitting</NavLink>
            <NavLink href="/docs/tool-integrations">
              Tool-Specific Formats
            </NavLink>
          </Nav>
        </Col>
        <Col xs={9}>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}
